import { defineStore } from "pinia";

// Concurrent-fetch dedupe map — sits outside Pinia state so the Promise
// isn't deep-proxied. Multiple elements with the same digital product id
// share one in-flight request.
const inFlight = new Map();

// Editor-tree digital product cache. Mirrors the story/event stores —
// production rendering of the Digital Product Details Page lazy-fetches
// the record by id (resolved from the URL via providesContexts) and
// caches it so subsequent reads from the element mixins are sync.
export const useDigitalProductStore = defineStore("dynamic-component-editor-digital-product-store", {
  state: () => ({
    digitalProducts: {},
  }),
  actions: {
    async getOrFetchDigitalProduct(digitalProductId) {
      if (!digitalProductId) {
        return null;
      }
      const cached = this.digitalProducts?.[digitalProductId];
      if (cached?.digitalProductId || cached?.digital_product_id) {
        return cached;
      }
      if (inFlight.has(digitalProductId)) {
        return await inFlight.get(digitalProductId);
      }
      const promise = new Promise(resolve => {
        this.apiGet(
          "/publication-digital-products",
          { entity_id: digitalProductId },
          data => {
            if (!this.digitalProducts || typeof this.digitalProducts !== "object") {
              this.digitalProducts = {};
            }
            this.digitalProducts[digitalProductId] = data;
            resolve(data);
          },
          () => resolve(null),
        );
      }).finally(() => {
        inFlight.delete(digitalProductId);
      });
      inFlight.set(digitalProductId, promise);
      return await promise;
    },
  },
});
